module.exports = __webpack_public_path__ + "img/not-authorized.6cc23f4c.png";